import React from 'react';
import { Hero } from './components/Hero';
import { ProofStrip } from './components/ProofStrip';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { Testimonials, firstWave, secondWave } from './components/Testimonials';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="2wjql9i09eorx">
      <Hero data-id="element-1" data-mp="2whxcnx635uha" />
      <Testimonials items={firstWave} data-id="element-2" data-mp="28ufpyg1ohml6" />
      <ProofStrip data-id="element-3" data-mp="28te2td7e19n3" />
      <main data-id="element-4" data-mp="28suvsrja05nu">
        <PainPoints data-id="element-5" data-mp="28sbbj465l56n" />
        <Tomos data-id="element-6" data-mp="23vck4tdvjcc5" />
        <Bonos data-id="element-7" data-mp="23vuokdaowwv5" />
        <Pricing data-id="element-8" data-mp="23w4c7u89irxo" />
        <Guarantee data-id="element-9" data-mp="23ujha3i1d6za" />
        <FAQ data-id="element-10" data-mp="23t8hsfvmildz" />
        <Testimonials items={secondWave} variant="dark" title="Lo que cambió en sus cocinas" data-id="element-11" data-mp="23ti67z10skhk" />
        <FinalCTA data-id="element-12" data-mp="3mkrdnl64zhdb" />
      </main>
      <Footer data-id="element-13" data-mp="3mjzuj9tq7c3x" />
      <StickyCTA data-id="element-14" data-mp="3mjg9hk8s47lo" />
    </div>;
}